import { Link } from 'react-router'
import styled from 'styled-components'

import { PairIcon, PairTicker } from '@root/entities/pair/ui/common'
import { TradeRoute } from '@root/features/routing'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const CreatorPairsTablePairCell: React.FC<Props> = ({ pair }) => (
  <Root
    to={TradeRoute.build({
      pairAddress: pair.address,
      network: pair.network,
    })}
  >
    <PairIcon
      pair={pair}
      size={28}
      withPairPopover
      withGoogleLens={false}
      withPreview={false}
    />
    <Ticker pair={pair} asLink={false} />
  </Root>
)

const Root = styled(Link)`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 8px;
  padding-inline: 0 4px;
`

const Ticker = styled(PairTicker)`
  font-size: 12px;
  font-weight: 500;
`
